import { render, staticRenderFns } from "./ModalTabVideos.vue?vue&type=template&id=0e938cb0&scoped=true&"
import script from "./ModalTabVideos.vue?vue&type=script&lang=js&"
export * from "./ModalTabVideos.vue?vue&type=script&lang=js&"
import style0 from "./ModalTabVideos.vue?vue&type=style&index=0&id=0e938cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e938cb0",
  null
  
)

export default component.exports